export default "__VITE_ASSET__UeiKcjta__"